import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ScrollText, ChevronRight } from 'lucide-react';

// Rappel sur l'accueil formateur tant que la charte n'est pas acceptée
export const BandeauCharteASigner = () => {
  const [aSigner, setASigner] = useState(false);
  useEffect(() => {
    axios.get('/charte-formateurs/moi').then(({ data }) => setASigner(!data.signee)).catch(() => setASigner(false));
  }, []);
  if (!aSigner) return null;
  return (
    <Link to="/ma-charte" data-testid="bandeau-charte-a-signer"
      className="group flex items-center gap-4 rounded-xl border border-amber-300 bg-amber-50 px-5 py-4 text-amber-900 transition-colors duration-200 hover:bg-amber-100">
      <ScrollText className="h-6 w-6 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold">Charte des formateurs à signer</p>
        <p className="text-sm text-amber-800">Merci de lire et signer la charte des formateurs FISL (une seule fois).</p>
      </div>
      <ChevronRight className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" />
    </Link>
  );
};
